import { IGrant, IMatchedGrant, IRejectedGrant, ISolicitation } from '../../../types/Grants'
import moment from 'moment/moment'
import { convertPhase } from '../../../utils'

export const normalizeTechGrants = (grants:IRejectedGrant[] | IMatchedGrant[]) => {
  return grants.map((g: IRejectedGrant | IMatchedGrant) => {
    const {
      like,
      status,
      feedback = '',
      progressStatus,
      _id: refId = '',
      technologyTitle = '',
      technologyId = '',
      grant = {} as IGrant,
      outcome: grantOutcome = 'pending',
      solicitation = {} as ISolicitation,
    } = g

    const {
      _id = '',
      topicId = '',
      awards_phaseI = '',
      awards_phaseII = '',
      topic_title: topicTitle = '',
      subtopic_title: subTopicTitle = ''
    } = grant

    const {
      type = [],
      phase = [],
      agency = '',
      close_date = '',
      agency_url: agencyUrl = '',
      solicitation_link: solicitationLink = 'N/A',
    } = solicitation

    const grantType = type.includes("federal") ? "Federal opportunities" : "Small business"

    const closeDate =
      (close_date && moment.utc(solicitation.close_date).format('MMMM D, YYYY')) || ''

    const awardsPhaseI =
      awards_phaseI === 'none' || awards_phaseI === '' ? 0 : parseInt(awards_phaseI, 10)
    const awardsPhaseII =
      awards_phaseII === 'none' || awards_phaseII === '' ? 0 : parseInt(awards_phaseII, 10)

    const totalAwardAmount = awardsPhaseI + awardsPhaseII

    const formattedAwardAmount = totalAwardAmount.toLocaleString('en-US')

    const formattedPhase = convertPhase(phase)

    const outcome = grantOutcome === 'N/A' ? 'pending' : grantOutcome

    return {
      _id,
      like,
      refId,
      status,
      agency,
      topicId,
      outcome,
      feedback,
      agencyUrl,
      grantType,
      closeDate,
      topicTitle,
      technologyId,
      awardsPhaseI,
      awardsPhaseII,
      progressStatus,
      technologyTitle,
      totalAwardAmount,
      solicitationLink,
      formattedAwardAmount,
      phase: formattedPhase,
      title : subTopicTitle || topicTitle,
    }
  })
}
